<template>
  <h2 class="screen-heading">
    <slot />
  </h2>
</template>

<style lang="scss" scoped>
.screen-heading {
  font-size: 36px;
  line-height: $fs6;
  margin-bottom: $spacer-6;
  font-weight: 500; // Required for safari to match chrome
}
</style>
